import { SVGProps, Ref, forwardRef } from 'react';

export const DocumentVerifiedOutlinedSize32Glyph = forwardRef(
    (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
        <svg
            width={32}
            height={32}
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={ref}
            {...props}
        >
            <g>
                <path d="M23.697 12 22 10.303l-8 8-4-4L8.303 16 14 21.697z" fill="currentColor" />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M28 30.667H4V1.333h13.333C25.333 1.333 28 4 28 12zm-21.6-2.4V3.733h10.933c3.867 0 5.682.676 6.637 1.63.954.956 1.63 2.77 1.63 6.637v16.267z"
                    fill="currentColor"
                />
            </g>
        </svg>
    )
);
DocumentVerifiedOutlinedSize32Glyph.displayName = 'DocumentVerifiedOutlinedSize32Glyph';
